import { ref, computed } from 'vue';
import dayjs from 'dayjs';
import type { Payments } from '@aviata/platform-types';

import { getBillById } from '@/entities/bill';

export const useSurcharge = () => {
  const bill = ref<Payments.Bill.Entity>();
  const hasError = ref(false);
  const isLoading = ref(false);

  const isPaid = computed(() => bill.value?.status === 'PAID');
  const isExpired = computed(() => bill.value?.status === 'EXPIRED');

  const expiresAt = computed(() => {
    const expiresIn = bill.value?.expires_in;
    if (expiresIn) {
      return dayjs().add(expiresIn, 'seconds').toString();
    }
    return null;
  });

  const fetchBill = (billId: string) => {
    isLoading.value = true;
    return getBillById({ billId })
      .then(res => (bill.value = res))
      .catch(() => (hasError.value = true))
      .finally(() => (isLoading.value = false));
  };

  return {
    bill,
    expiresAt,
    isPaid,
    isExpired,
    isLoading,
    hasError,
    fetchBill,
  };
};
